module.exports = __webpack_public_path__ + "img/clock.59df01fd.svg";